import { Image, Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { H2, BodyText } from "src/atoms/typography";
import { SceneLayout } from "src/components/SceneLayout";
import NavigationButtons from "src/components/NavigationButtons";
import getImageSrc from "src/utils/getImageSrc";

export default function PairingSuccess({
  text,
  onDone,
  mode,
  onBack,
  onClose
}) {
  const { t } = useTranslation();
  return (
    <>
      <NavigationButtons mode={mode} onBack={onBack} onClose={onClose} />

      <SceneLayout
        centerProps={{ width: "320px" }}
        center={
          <>
            <Image src={getImageSrc("success.svg")} width="176px" />
            <H2 color="highEmphasis" textAlign="center" mt="24px">
              {t("pawesome")}
            </H2>
            <BodyText color="mediumEmphasis" textAlign="center" mt="8px">
              {text}
            </BodyText>
          </>
        }
        bottomProps={{ mb: "24px" }}
        bottom={
          <>
            <Button
              variant="containedPrimary"
              onClick={onDone}
              mt="32px"
              minWidth="120px"
            >
              {t("buttons.done")}
            </Button>
          </>
        }
      />
    </>
  );
}
